const CONTEXT = (window.siteConfig?.()?.contextPath ?? '').replace(/\/+$/, '');

const get = async () => {
    try {
        const response = await fetch(`${CONTEXT}/.rest/country/getCountry`, {
            // uncomment the line for locale testing
            // headers: { 'X-Forwarded-For': '101.33.10.3' },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status Code ${response.status}!`);
        }

        return (await response.text()) || undefined;
    } catch (e) {
        console.log('Error fetching country:', e);
        return null;
    }
};

const CountryService = {
    get,
};

export { CountryService };
